import BaseStorageService from './base';

class EaseMobStorage extends BaseStorageService {
  private tokenKey = 'EaseMob_Token';
  setToken(token: string) {
    this.setItem(this.tokenKey, token);
  }

  getToken(): string | undefined {
    return this.getItem(this.tokenKey);
  }

  clearToken() {
    this.removeItem(this.tokenKey);
  }
}

export default EaseMobStorage;
